import Component from './Component.vue'
import Selection from './Selection.vue'

export default {
  guid: 'b0bca8b297674792a6f4489d272b8230',
  component: Component,
  selection: Selection,
  paymentCallback() {

  }
}
